export default "__VITE_ASSET__BfjYdRWa__"